module.exports = __webpack_public_path__ + "static/media/s1.0c039302.png";